<!--
 * @Author: MouXiaowei
 * @Date: 2023-03-29 14:24:02
 * @Description: 国信通积分抽奖
-->
<template>
    <div class="gxt-lottery">
        <!-- 抽奖机 -->
        <div class="lottery-box">
            <img class="lottery-top-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_top.png"/>
            <div class="lottery-merchine">
                <img v-if="lotteryStart" class="lottery-merchine-gif" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery.gif"/>
                <div v-else class="lottery-merchine-content">
                    <div class="lottery-merchine-item">
                        <img v-if="requestSuccess" class="lottery-gift" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_gift3.png"/>
                        <img v-else class="lottery-gift" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_gift1.png"/>
                    </div>
                    <div class="lottery-merchine-item">
                        <img v-if="requestSuccess"  class="lottery-gift" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_gift3.png"/>
                        <img v-else class="lottery-gift" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_gift2.png"/>
                    </div>
                    <div class="lottery-merchine-item">
                        <img v-if="requestSuccess"  class="lottery-gift" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_gift3.png"/>
                        <img v-else class="lottery-gift" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_gift3.png"/>
                    </div>
                </div>
            </div>
            <div class="lottery-bottom">
                <img v-if="lotteryCount <= 0" class="lottery-btn" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_btn_end.png" @click="handleGoUse"/>
                <img v-else class="lottery-btn" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_btn_start.png" @click="handleStart"/>
                <div v-if="requestSuccess" class="lottery-info">{{resInfo.prizeDesc}}</div>
            </div>
            <div class="right-box">
                <img v-if="rightIsChecked" class="check-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_selected.png" @click="handleRightBtnClick"/>
                <img v-else class="check-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_unselected.png" @click="handleRightBtnClick"/>
                <div class="right-title"  @click="handleRightClick">已阅读并同意 <span class="right-content">《国信通平台会员服务协议》</span></div>
            </div>

             <!-- 热销商品 -->
            <div class="goods-box">
                <div class="goods-content">
                    <img class="goods-item" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_goods1.png"/>
                    <img class="goods-item" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_goods2.png"/>
                    <img class="goods-item" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_goods3.png"/>
                </div>
            </div>
        </div>

        <!-- 活动说明 -->
        <div class="rule-box">
            <img class="rule-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_rule.png"/>
        </div>
    </div>
</template>
<script>
import { setStore } from '@/utils/index'
import { getLotteryInfo, getLotteryRes, geWXMiniappScheme, getGXTMemberState, openGXTMember } from '@/api/active'
import { Toast } from 'vant'
const wx = require('weixin-js-sdk')

export default {
  name: 'gxtLottery',
  components: {
  },
  data () {
    return {
      type: '',
      token: '',
      rightIsChecked: true,
      lotteryStart: false,
      requestSuccess: false,
      time: 0,
      activityId: null, // 抽奖活动id
      bgColor: null, // 背景色
      bgUrl: null, // 背景图
      remark: null, // 活动描述
      prizeInfoList: [], // 奖项列表
      lotteryCount: null, // 今日可用抽奖次数
      isShowRewardDialog: false, // 中奖弹框
      resInfo: null, // 中奖信息
      urlScheme: '',
      isNeedOpen: false // 是否需要去开通国信通
    }
  },
  mounted () {
    const token = this.$route.query.accessToken
    this.token = token
    if (token) {
      setStore('token', token)
    }
    const type = this.$route.query.type
    if (type) {
      this.type = type
    }
    this.activityId = this.$route.query.activityId
    this.getLotteryInfo()
    this.getGXTMemberState()
    // this.getGXTUrlSchemeInfo()
  },
  methods: {
    // 国信通平台会员服务协议查看
    handleRightClick () {
      this.$router.push('../gxtRightPolicy')
    },

    // 国信通协议同意按钮点击
    handleRightBtnClick () {
      this.rightIsChecked = !this.rightIsChecked
    },

    // 开始抽奖
    handleStart () {
      if (!this.rightIsChecked) {
        Toast({
          message: '请先同意《国信通平台会员服务协议》！'
        })
        return
      }
      if (this.isNeedOpen) {
        Toast({
          message: '您的国信通会员未开通！'
        })
        return
      }
      if (this.lotteryCount <= 0) {
        Toast({
          message: '今日抽奖次数已用完！'
        })
        return
      }
      this.lotteryStart = true
      this.time = 3
      this.timer()
    },

    timer () {
      if (this.time > 0) {
        this.time--
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.getLotteryRes()
      }
    },

    // 去使用
    handleGoUse () {
      if (this.type && this.type.length > 0) {
        dsBridge.call('callNativeViewLifeCycle', {
          androidGoPage: 'gh_9031064d65ec',
          iosGoPage: 'gh_9031064d65ec',
          appId: '1812100002',
          appType: 3,
          appStartUrl: '/pages/index/index',
          authorize: 0,
          loginL: 1,
          miniAppId: 'wxee6d26a6c81f72fc'
        })
      } else {
        // wx.miniProgram.postMessage({})
        // wx.miniProgram.navigateBack({})
        wx.miniProgram.navigateTo({ url: '/pages/index/wxMiniAppJump' })
        // window.location.href = this.urlScheme
      }
    },

    // 获取国信通小程序URL Scheme
    getGXTUrlSchemeInfo () {
      geWXMiniappScheme('/pages/index/index').then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.urlScheme = res.data.result
            }
          }
        }
      })
    },

    // 查询国信通开通状态
    getGXTMemberState () {
      getGXTMemberState().then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              const state = res.data.result.openStatus
              if (state === true) {
                // 已开通
                this.isNeedOpen = false
              } else if (state === false) {
                // 未开通
                this.openGXTMember()
              }
            }
          }
        }
      })
    },

    // 开通国信通会员
    openGXTMember () {
      const requestData = {
        openOption: 2
      }
      openGXTMember(requestData).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              const state = res.data.result.openStatus
              if (state === true) {
                this.isNeedOpen = false
              } else {
                this.isNeedOpen = true
                Toast('国信通会员开通失败')
              }
            }
          }
        }
      })
    },

    // 获取中奖活动详情信息
    getLotteryInfo () {
      getLotteryInfo(this.activityId).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.bgColor = res.data.result.backgroundColor
              this.bgUrl = 'url(' + res.data.result.iconUrl + ')'
              this.prizeInfoList = res.data.result.prizeInfoList
              this.lotteryCount = res.data.result.lotteryCount
              this.remark = res.data.result.remark
            }
          }
        }
      })
    },
    // 抽奖
    getLotteryRes () {
      getLotteryRes(this.activityId).then((res) => {
        this.lotteryCount -= 1
        this.lotteryStart = false
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              this.resInfo = res.data.result
              this.requestSuccess = true
            }
          }
        }
      }).catch(() => {
        this.lotteryStart = false
      })
    }
  }
}
</script>
<style lang="scss">
.gxt-lottery {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FFCC99;

  .lottery-box {
    width: 100%;
    background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_bg.png') no-repeat;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .lottery-top-img {
      margin-top: (336vw / 7.5);
      width:  (685vw / 7.5);
      height:  (116vw / 7.5);
    }

    .lottery-merchine {
      width: (683vw / 7.5);
      height: (244vw / 7.5);
      background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_center.png') no-repeat;
      background-size: 100%;
      .lottery-merchine-gif {
        margin-left: (97vw / 7.5);
        margin-top: (34vw / 7.5);
        width: (447vw / 7.5);
        height: (160vw / 7.5);
      }
      .lottery-merchine-content {
        margin-left: (97vw / 7.5);
        margin-top: (34vw / 7.5);
        width: (447vw / 7.5);
        height: (160vw / 7.5);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .lottery-merchine-item {
          width: (107vw / 7.5);
          height: (158vw / 7.5);
          background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_gift_bg.png') no-repeat;
          background-size: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          .lottery-gift {
            width: (74vw / 7.5);
            height: (74vw / 7.5);
          }
        }
      }
    }
    .lottery-bottom {
        width: (663vw / 7.5);
        height: (223vw / 7.5);
        background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_machine_bottom.png') no-repeat;
        background-size: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .lottery-btn {
          width: (260vw / 7.5);
          height: (115vw / 7.5);
        }
        .lottery-info {
          height: (100vw / 7.5);
          font-size: (36vw / 7.5);
          font-weight: 900;
          color: #fff;
          line-height: (100vw / 7.5);
          text-align: center;
        }
      }

      .right-box {
        margin-top: (30vw / 7.5);
        margin-bottom: (30vw / 7.5);
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .check-img {
          width: (32vw / 7.5);
          height: (32vw / 7.5);
        }
        .right-title {
          margin-left: (20vw / 7.5);
          font-size: (28vw / 7.5);
          font-weight: 400;
          color: #BE650C;
          line-height: (40vw / 7.5);
        }
        .right-content {
          margin-left: (4vw / 7.5);
          font-size: (28vw / 7.5);
          font-weight: 400;
          color: #61370D;
          line-height: (40vw / 7.5);
        }
      }
  }

  .goods-box {
    width: (720vw / 7.5);
    background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/lottery/gxtActivity/gxt_lottery_goods_bg.png') no-repeat;
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .goods-content {
      margin-top: (174vw / 7.5);
      display: flex;
      flex-direction: column;
      align-items: center;

      .goods-item {
        margin-bottom: (26vw / 7.5);
        width: (690vw / 7.5);
        height: (524vw / 7.5);
      }
    }
  }

  .rule-box {
    margin-top: (50vw / 7.5);
    margin-bottom: (50vw / 7.5);
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .rule-img {
      width: (690vw / 7.5);
    }
  }
}
</style>
